import type { ZodIssueMetadata } from '@safc/configuration';

export const issueFormCleanup = (metadata: ZodIssueMetadata): ZodIssueMetadata => {
  {
    /**
     * Case facts:
     * 1. old issuances (v1) do not have additionality approach
     * 2. New issuances (v2) enable if additionality approach is defined
     * 3. Our edit form adds `batch.additionalityApproach = { type: undefined }` (can't do much about it)
     *
     * If you edit old issuance, additonalityApproach `{}` gets set, and old issuance uses v2 calculations. We have to prevent that.
     *
     * Alternative: proper versioning of schemas and whatnot
     */
    const batch = metadata.batch as Omit<ZodIssueMetadata['batch'], 'additionalityApproach'> & { additionalityApproach: ZodIssueMetadata['batch']['additionalityApproach'] | undefined };
    if (batch.additionalityApproach?.type === undefined) {
      batch.additionalityApproach = undefined;
    }
  }

  return metadata;
};
